<template>
  <v-container />
</template>

<script>
  export default {
    name: 'Logout',

    mounted() {
      console.log('logout clicked');
      const office =  JSON.parse(String(localStorage.getItem('user'))).office;
      this.$store.dispatch('auth/logout');
      this.$router.push(`/${office}/pages/login`);
      // eslint-disable-next-line no-console
      console.log('logout clicked - end');
    }
  }
</script>
